import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { memo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import useLegacyProps from '../../hooks/useLegacyProps.js';

var _excluded = ["children", "isHoverable", "theme"];
var _templateObject;
var StyledTableRow = styled('tr')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n  border-bottom: 1px solid ", ";\n  &:last-child {\n    border-bottom: none;\n  }\n\n  th,\n  td {\n    border-color: ", ";\n    border-width: ", ";\n    border-style: ", ";\n  }\n"])), function (_ref) {
  var isFilled = _ref.isFilled,
    _ref$theme = _ref.theme,
    palette = _ref$theme.palette,
    table = _ref$theme.table;
  return isFilled ? palette[table.rowBandingColor] : palette[table.backgroundColor];
}, function (_ref2) {
  var isHoverable = _ref2.isHoverable,
    _ref2$theme = _ref2.theme,
    palette = _ref2$theme.palette,
    table = _ref2$theme.table;
  return isHoverable ? palette[table.rowBandingColor] : null;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.gray;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.table.borderColor ? theme.palette[theme.table.borderColor] : '';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.table.borderWidth;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.table.borderStyle;
});
var TableRow = function TableRow(_ref7) {
  var children = _ref7.children,
    _ref7$isHoverable = _ref7.isHoverable,
    isHoverable = _ref7$isHoverable === void 0 ? true : _ref7$isHoverable,
    _ref7$theme = _ref7.theme,
    theme = _ref7$theme === void 0 ? themes["default"] : _ref7$theme,
    rest = _objectWithoutProperties(_ref7, _excluded);
  var _useLegacyProps = useLegacyProps(rest),
    className = _useLegacyProps.className,
    style = _useLegacyProps.style;
  return /*#__PURE__*/React.createElement(StyledTableRow, _extends({
    theme: theme,
    isHoverable: isHoverable
  }, rest, {
    className: className,
    style: style
  }), children);
};
var _TableRow = withDefaultTheme(/*#__PURE__*/memo(TableRow));

export default _TableRow;
